angular.module('rjmNg.directives').directive "sqlReportAction", [
  () ->
    restrict: "E"
    templateUrl: "directive.sqlReportAction.html"
    replace: false
    controllerAs: "view"
    bindToController: true
    scope:
      currentFigure: "="
    controller: [
      "app"
      "$routeParams"
      "$location"
      "appRoute"
      (
        app
        $routeParams
        $location
        appRoute
      ) ->

        view = @
        view.dashboard = app.getDashboard($routeParams.dashboardId)
        view.lastSaveTimestamp = 0

        # Parameters for saveFigureDirective
        view.scalars = []
        view.lastSaveTimestamp = 0
        view.savingInProgress = false
        view.selectedMetrics = []
        view.figureIsUnused = true

        view.saveSuccessCallback = (figure, dashboard) ->
          view.dashboard = dashboard
          currentDate = new Date()
          view.lastSaveTimestamp = currentDate.getTime()

        view.figureIsUnused = true
        view.gotoDashboard = (id) ->
          # Send them back to the dashboard they came from or the default dashboard
          $location.url appRoute("/#{id}")

        return view
    ]
]
